import axiosInstance, { protectedAxiosInstance } from "@/utils/axiosConfig"
import {
	setObjectLocalStorageCondition,
	clearTokensFromLocalStorage
} from "@/utils/localStorageExpire"

export default {
	actions: {
		async LOGIN_USER({ commit }, credentials) {
			const { data } = await axiosInstance.post("/auth/login", {
				...credentials
			})
			const { success, data: tokenData, activateFirst, tokens } = data
			if (activateFirst) {
				commit("register/SET_ACTION_TOKEN", tokenData.actionToken, {
					root: true
				})
				return data
			}
			setObjectLocalStorageCondition(tokens, success)
			commit("SET_AUTHENTICATED", true, {
				root: true
			})
			return data
		},
		async LOGOUT_USER({ commit }) {
			// if (state.AUTHENTICATED) {
			await protectedAxiosInstance.get("/auth/logout")
			clearTokensFromLocalStorage()
			commit("SET_AUTHENTICATED", false, { root: true })
			commit(
				"SET_MY_PROFILE",
				{
					email: "",
					activated: false,
					name: "",
					nickname: ""
				},
				{ root: true }
			)
		}
	},
	namespaced: true
}
